import { useEffect, useState } from 'react'

interface LottieLoopHandlerReturnType {
  handleOnMouseOver: (id: number) => void
  handleOnMouseLeave: () => void
  handleLoopComplete: () => void
  handleIsStopped: (id: number) => boolean
}

export const useLottieLoopHandler = (
  loopLength: number,
  isMobile: boolean
): LottieLoopHandlerReturnType => {
  const [isLoopPaused, setIsLoopPaused] = useState(true)
  const [activeLottie, setActiveLottie] = useState(1)
  const [hoveredId, setHoveredId] = useState(-1)

  const handleScroll = () => {
    const { scrollTop, scrollHeight } = document.documentElement

    const blockStartPosition = (scrollTop * 100) / scrollHeight

    if (blockStartPosition >= 34 && blockStartPosition < 50) {
      setIsLoopPaused(false)
    } else {
      setIsLoopPaused(true)
      setActiveLottie(1)
    }
  }

  useEffect(() => {
    document.addEventListener('scroll', handleScroll)

    return () => document.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    handleScroll()
  }, [])

  const handleOnMouseOver = (id: number) => {
    setHoveredId(id)
    setIsLoopPaused(true)
    setActiveLottie(id)
  }

  const handleLoopComplete = () => {
    if (activeLottie < loopLength + 1 && isLoopPaused && hoveredId === -1) {
      setActiveLottie(prev => prev + 1)
    }
  }

  const handleOnMouseLeave = () => {
    setIsLoopPaused(true)
    setHoveredId(-1)
  }

  const handleIsStopped = (id: number) => {
    if (id === hoveredId) {
      return false && !isLoopPaused
    }
    return id !== activeLottie || isLoopPaused || isMobile
  }

  return {
    handleOnMouseOver,
    handleOnMouseLeave,
    handleLoopComplete,
    handleIsStopped,
  }
}
